<template>
  <div
    :class="topBarInsetClass"
    class="flex cursor-pointer items-center justify-between border-b border-gpx_gray-900 bg-white"
    title="Go back"
    @click="goBack"
  >
    <div>
      <UIIconButton
        icon="ArrowUturnLeftIcon"
        @click="goBack"
        tooltip="Go back"

      />
    </div>
    <div>
      <span class="text-[18px] font-semibold leading-6 text-gpx_black-50">
        {{ name }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as _ from 'lodash';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGroup } from '@/composables/useGroup.ts';
import { storeToRefs } from 'pinia';
import { topBarInsetClass } from '@/components/_common/navbar/topBarInset';

const route = useRoute();
const router = useRouter();

const groupStore = useGroup();
const { getById } = groupStore;
const { search } = storeToRefs(groupStore);

const group = computed(() => getById(+route.params.id));
const name = computed(() => _.get(group.value, 'name', 'No Name'));

function goBack() {
  router.push({
    name: 'GroupListView',
    query: { search: search.value },
  });
}
</script>
